<template>
  <v-card class="elevation-4">
    <v-card-title class="justify-start py-2 card-modaltitle">
      <div class="pl-4">
        <h3 class="primary--text">
          ¡Asignación no permitida, utilice un conductor alternativo!
        </h3>
      </div>
      <v-btn depressed text color="primary" class="cont" @click="$emit('close')">
        <v-icon class="mr-1">fa-solid fa-xmark</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <div class="alert-body">
        <p class="mb-4"><b>Motivo:</b> Conductor con documentos vencidos.</p>

        <div class="list">
          <p v-for="(doc, idx) in orderedDocs" :key="idx" class="list-item">
            {{ idx + 1 }}. {{ doc.description }} {{ formatExpirationDate(doc.dateExpiration) }}
          </p>
        </div>

        <p class="mt-4">
          El conductor {{ driverName }} no cumple con los requisitos necesarios para esta asignación.
        </p>
      </div>

      <v-row class="justify-end mt-4 pr-2">
        <v-btn color="primary" depressed @click="$emit('close')">Aceptar</v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'DriverDocumentsAlertModal',
  props: {
    driverName: { type: String, default: '' },
    documents: { type: Array, default: () => [] }
  },
  computed: {
    orderedDocs() {
      const getOrder = (desc = '') => {
        const d = String(desc);
        if (/eps/i.test(d)) return 1;
        if (/arl/i.test(d)) return 2;
        if (/(manipulación|manipulacion)/i.test(d)) return 3;
        return 99;
      };
      return this.documents.slice().sort((a, b) => getOrder(a?.description) - getOrder(b?.description));
    }
  },
  methods: {
    formatExpirationDate(expirationDate) {
      if (!expirationDate) return 'Fecha no disponible';
      const date = new Date(expirationDate);
      if (isNaN(date.getTime())) return 'Fecha no disponible';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
  }
};
</script>

<style scoped>
.card-modaltitle {
  border-bottom: 1px solid #ccc;
}

.alert-body {
  white-space: pre-line;
}

.list {
  margin-left: 8px;
}

.list-item {
  margin: 6px 0;
  padding-left: 8px;
}

.cont {
  position: absolute;
  right: 10px;
}
</style>